<div class="mb-3">
  <label [for]="controllerName" class="form-label" [translate]="label"
    [ngClass]="{'fw-bold': formControl.dirty}"></label>
  @if(required){
  <label class="text-danger">*</label>
  }
  @if(!multiple) {
  <select [id]="controllerName" class="form-select" [formControl]="formControl"
    [style.backgroundColor]="backgroundColor" [attr.disabled]="disabled"
    [ngClass]="!formControl?.touched? '' : formControl?.invalid ? 'is-invalid': 'is-valid'" [required]="required">
    <option [ngValue]="null" disabled selected translate="shared.choose"></option>
    @for (data of options; track data.key){
    <option [ngValue]="data.key" [translate]="isEnum? data.name : isRtl? data.nameAr : data.name">
    </option>
    }
  </select>
  }

  @if(multiple) {
  <div class="custom-multi-select"
    [ngClass]="!formControl?.touched? '' : formControl?.invalid ? 'is-invalid': 'is-valid'">
    @for (data of options; track data.key) {
    <div class="custom-option" [class.selected]="isOptionSelected(data.key)" (click)="toggleOption(data.key)">
      <span [translate]="isEnum ? data.name : isRtl ? data.nameAr : data.name"></span>
    </div>
    }
  </div>
  }

  @if (formControl?.invalid && (formControl?.touched || formControl?.dirty)) {
  <div role="alert">
    @for (error of checkControllerErrors(); track $index) {
    <p class="invalid-feedback" [translate]="error"></p>
    }
    @if (formControl?.errors?.['pattern']) {
    <p class="invalid-feedback" [translate]="customError"></p>
    }
  </div>
  }
</div>

